import { render, staticRenderFns } from "./ModalNewRoomControl.vue?vue&type=template&id=6b4a4e08&"
import script from "./ModalNewRoomControl.vue?vue&type=script&lang=js&"
export * from "./ModalNewRoomControl.vue?vue&type=script&lang=js&"
import style0 from "./ModalNewRoomControl.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports